import React, { useState } from 'react';
import { connect } from 'react-redux';

import { Accordion, AccordionTitle, AccordionContent, Icon, Button } from 'semantic-ui-react';

const MembersBlockView = ({ isAuthenticated, data, isEditMode }) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (e, { index }) => {
    setActiveIndex((prev) => (prev === index ? -1 : index));
  };

  const getItemsFromData = (data = {}) => {
    if (Array.isArray(data.items)) {
      return data.items.map((it, i) => ({
        title: it?.title || `Item ${i + 1}`,
        description: it?.description || '',
      }));
    }
    return [];
  };

  const items = getItemsFromData(data);

  const showRegisterBox =
    data.show_register_box !== false && data.show_register_box !== 'false';
  const regHeading = data.register_heading || 'Not yet registered?';
  const regText =
    data.register_text ||
    'Create an account to access all member resources and events.';
  const signupLabel = data.signup_label || 'Sign up';
  const loginLabel = data.login_label || 'Log in';


  return (
    <div className="block members">
      {data.heading && <h2>{data.heading}</h2>}

      {items.length === 0 ? (
        isEditMode ? (
          <div className="members-empty-hint">
            <em>No items yet. Use the sidebar to add your first accordion item.</em>
          </div>
        ) : null
      ) : (
        <Accordion fluid>
          {items.map((item, index) => {
            const isOpen = activeIndex === index;

            return (
              <React.Fragment key={index}>
                <AccordionTitle
                  active={isOpen}
                  index={index}
                  onClick={handleClick}
                  className="members-accordion-title"
                  aria-expanded={isOpen}
                >
                  <Icon fitted name={isOpen ? 'caret down' : 'caret right'} />
                  {item.title}
                </AccordionTitle>
                <AccordionContent active={isOpen} className={'members-accordion-content' + (isOpen ? ' is-open' : '')}

                >
                  <div className="members-accordion-content__inner">
                    {item.description ? <p>{item.description}</p> : null}
                  </div>
                </AccordionContent>
              </React.Fragment>
            );
          })}
        </Accordion>
      )}

      {(!isAuthenticated || isEditMode) && showRegisterBox && (
        <div className="register-box">
          <h3>{regHeading}</h3>
          <p>{regText}</p>
          <div className="register-actions">
            <Button as="a" href="/register" className="signup">
              {signupLabel}
            </Button>
            <Button as="a" href="/login" className="login">
              {loginLabel}
            </Button>
          </div>
        </div>
      )}

    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: !!(state.userSession && state.userSession.token),
});

export default connect(mapStateToProps)(MembersBlockView);